import HospitalLogDBService from "../../db-services/hospitalLogDBService";
import { ILogResponseModel } from "../types";


class HospitalLogService {
    private dbService;

    constructor() {
        this.dbService = new HospitalLogDBService();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default HospitalLogService;
